export const DOCUMENT_UPLOAD_LIMIT = {
  maxFileSizeBytes: 100 * 1024 * 1024,
  displayText: '100MB',
}
